import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import Spinner from '../../components/Spinner'
import * as UI from '../../lib/ui'
import { getShows } from '../../actions/contentActions'
import { store } from '../../store'
import { ComcastErrorType } from '../../../../shared/helpers.js'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import CollectionsSet from '../../components/CollectionsSet'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

export class ShowsScreen extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      spinnerVisible: true,
      errorVisible: false,
    }
    UI.setLoadingState(true)
  }

  componentDidMount() {
    this.getShowData()

    googleAnalytics4.sendPageViewEvent('Shows')
    // GOOGLE ANALYTICS
    /* window.ga('set', 'dimension1', callSign)
    window.ga('set', 'dimension2', UID)
    window.ga('set', 'dimension3', deviceModel)
    window.ga('send', 'pageview', 'Shows') */
  }

  getShowData = () => {
    getShows(this.props.stationId)
      .then((collectionsResponse) => {
        this.setState({
          collections: collectionsResponse.collections,
          spinnerVisible: false,
        })
        setTimeout(() => {
          UI.setLoadingState(false)
        }, 200)
      })
      .catch((error) => {
        UI.setLoadingState(false)
        store.dispatch({
          type: 'TRIGGER_ERROR',
          payload: {
            error,
            content: {
              errorPath: this.props.router.location.pathname,
            },
            codeBaseLocation: 'ShowsScreen - getShowData',
            errorType: ComcastErrorType.network,
          },
        })
        this.props.router.navigate('/error', { replace: true })
      })
  }

  render() {
    const { collections, spinnerVisible } = this.state

    return (
      <>
        {spinnerVisible && <Spinner />}
        {'undefined' !== typeof collections && (
          <CollectionsSet collections={collections} />
        )}
      </>
    )
  }
}

ShowsScreen.propTypes = {
  UID: PropTypes.string,
  callSign: PropTypes.string,
  deviceModel: PropTypes.string,
  stationId: PropTypes.string,
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    navigate: PropTypes.func,
  }),
}

const mapStateToProps = (state) => {
  return {
    stationId: state.station.station_id,
    UID: state.device.UID,
    callSign: state.station['call_sign'],
    deviceModel: state.device.deviceModel,
  }
}

export default connect(mapStateToProps, null, null)(withRouter(ShowsScreen))
